import axios from "axios";
import { auth } from "./firebase"

// Attende che Firebase imposti currentUser (con timeout breve)
const waitForCurrentUser = async (timeoutMs = 1000) => {
  try {
    if (typeof auth.authStateReady === 'function') {
      await auth.authStateReady()
    }
  } catch (_) { /* noop */ }
  const start = Date.now()
  while (!auth.currentUser && (Date.now() - start) < timeoutMs) {
    await new Promise(r => setTimeout(r, 50))
  }
  return auth.currentUser
}

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  timeout: "30000"
})

api.interceptors.request.use(async (config) => {
  // Salta auth nelle rotte specifiche
  if (config.url && config.url.includes("reset-password")) {
    return config
  }

  // Attendi brevemente che currentUser sia disponibile
  const user = await waitForCurrentUser()
  if (!user) {
    // Evita errori rumorosi: lascia proseguire senza header (potrebbe rispondere 401)
    // oppure potremmo scegliere di ritentare lato chiamante
    console.debug(`Auth not ready for request ${config.url}`)
    return config
  }

  const tokenResult = await user.getIdTokenResult()
  const token = tokenResult.token
  config.headers.Authorization = `Bearer ${token}`
  return config
}, (error) => {
  // Gestisci errori nell'interceptor
  return Promise.reject(error);
});

api.interceptors.response.use(async (response) => {
  if (![200, 201, 204].includes(response.status)) {
    return Promise.reject(response.data)
  }
  return response.data
}, async (error) => {
  if (error.response?.status === 500) {
    return Promise.reject({ code: 0, message: "Server Error", detail: "Il server non è disponibile. Riprova più tardi." })
  }
  if (error.response?.data) {
    if (error.config.showError === null || error.config.showError === undefined || error.config.showError === true) {
      document.dispatchEvent(new CustomEvent('api-error', { detail: error.response.data }));
    }
    if (error.response.data.code === 9) {
      console.debug("Profile suspended. Force logout")
      await auth.signOut()
      if (window.location.pathname !== "/login") {
        window.location.reload()
      }
    }
    return Promise.reject(error.response.data)
  }


  return Promise.reject(error)

})

export default api;
